angular.module('unica_feedback_category.feedback_category_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// feedback_category
		.state('app.feedback_category', {
			url: '/feedback-category',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/feedback-category/templates/feedback-category.html',
					controller: 'FeedbackCategoryBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

		// feedback_category LIST AND DELETE
		.state('app.feedback_category.list', {
			url: '/list/:event_id',
			views: {
				'feedbackCategoryContent': {
					templateUrl: './modules/feedback-category/templates/list.html',
					controller: 'FeedbackCategoryListController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Categorie Feedback',
				parent: function($scope) {
					return 'app.event.detail({year: ' + $scope.year + ',id:' + $scope.event_id + ' })';
				}
			}
		})

		// feedback_category CREATE
		.state('app.feedback_category.create', {
			url: '/create/:event_id',
			views: {
				'feedbackCategoryContent': {
					templateUrl: './modules/feedback-category/templates/create.html',
					controller: 'FeedbackCategoryCreateController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Aggiungi Categoria',
				parent: 'app.feedback_category.list'
			}
		})

		// feedback_category EDIT
		.state('app.feedback_category.edit', {
			url: '/edit/:event_id/:id',
			views: {
				'feedbackCategoryContent': {
					templateUrl: './modules/feedback-category/templates/edit.html',
					controller: 'FeedbackCategoryEditController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Modifica Categoria',
				parent: 'app.feedback_category.list'
			}
		});

});

